import { render, staticRenderFns } from "./MajMail.vue?vue&type=template&id=361e9846&"
import script from "./MajMail.js?vue&type=script&lang=js&"
export * from "./MajMail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports